import * as React from "react";
import { Link, navigate } from "gatsby";

import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import "/src/css/search.css";

import { search, getMonth } from "/src/services/utils";
import slugify from "slugify";
import { useState, useEffect } from "react";
import { SearchBar } from "/src/components/SearchBar";
import { v4 as uuidv4 } from "uuid";

const searchHere = async (query, callback) => {
  const blacklist = ["resourceLinks", "staff", "event"];
  let searchResults = await search(query);
  let results = [];
  for (const result of searchResults) {
    if (blacklist.includes(result.sys.contentType.sys.id)) {
      continue;
    }
    let data = {};
    let title = slugify(
      result.fields.title["en-SG"] || result.fields.title["en-US"],
      {
        lower: true,
        strict: true,
      }
    );
    let formattedDate = "";
    if (result.fields.createdAt) {
      let originalDate =
        result.fields.createdAt["en-SG"] || result.fields.createdAt["en-US"];
      let resultDate = new Date(originalDate);
      formattedDate =
        resultDate.getDate() +
        " " +
        getMonth(resultDate.getMonth()).substring(0, 3) +
        " " +
        resultDate.getFullYear();
    }

    let other = formattedDate ? formattedDate + "  |  " : "";
    other += result.fields.category
      ? result.fields.category["en-SG"] + "  |  "
      : "";
    other += result.fields.createdBy ? result.fields.createdBy["en-SG"] : "";
    data.title = result.fields.title["en-SG"] || result.fields.title["en-US"];
    data.other = other;
    data.description = result.fields.summary
      ? result.fields.summary["en-SG"] || result.fields.summary["en-US"]
      : "";
    switch (result.sys.contentType.sys.id) {
      case "blogPost":
        data.link = `/blog/${title}`;
        data.type = "blog";
        results.push(data);
        break;
      case "project":
        data.link = `/projects/${title}`;
        data.type = "projects";
        results.push(data);

        break;
      case "resources":
        //dont show ecochamp resources
        if (
          !(
            result.fields.isEcochamp &&
            (result.fields.isEcochamp["en-SG"] ||
              result.fields.isEcochamp["en-US"])
          )
        ) {
          data.link = `/resources/${title}`;
          data.type = "resources";
          results.push(data);
        }
        break;
      default:
        break;
    }
  }

  await callback(results);
};

const SearchPage = (props) => {
  const [searchQuery, setSearchQuery] = useState(
    (props.location.state && props.location.state.searchQuery) || ""
  );
  const [data, setData] = useState([]);
  const inputHandler = (e) => setSearchQuery(e.target.value);
  const submitHandler = () => {
    if (searchQuery === "" || searchQuery === undefined) {
      setData([]);
      return;
    }
    navigate("/search", {
      state: { searchQuery },
    });
    searchHere(searchQuery, setData);
  };

  useEffect(() => submitHandler(searchQuery, setData), []);

  return (
    <>
      <Seo title="Search" />
      <div className="search-maincontainer">
        <section className="search-searchbarcontainer">
          <SearchBar
            inputHandler={inputHandler}
            submitHandler={submitHandler}
            searchQuery={searchQuery}
            className="search-searchbar"
          />
        </section>
        <section className="search-resultscontainer">
          <h5 className="search-resultcount">
            -{" "}
            {data.length === 0
              ? "No results found"
              : data.length === 1
              ? "1 result"
              : data.length + " results"}{" "}
            -
          </h5>
          {data.length > 0 ? (
            data.map((val) => (
              <SearchResult
                key={uuidv4()}
                link={val["link"]}
                type={val["type"]}
                title={val["title"]}
                description={val["description"]}
                other={val["other"]}
              />
            ))
          ) : (
            <div></div>
          )}
        </section>
      </div>
    </>
  );
};

const SearchResult = ({
  link,
  type,
  title,
  description = null,
  other = null,
}) => {
  return (
    <div className="search-searchresult">
      <h5>
        {"https://magorium-impact" + link} {">"} {type}
      </h5>
      <h2>
        <Link to={link}>{title}</Link>
      </h2>
      <div className="search-searchresult-description">{description}</div>
      <h5>{other}</h5>
    </div>
  );
};

SearchPage.Layout = Layout;
export default SearchPage;
